(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.logo')
    .factory('LogoFactory', LogoFactory);

  function LogoFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';
    
    var LogoBase = {

      getAll: function(idEntitat){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.get(url);
      },

      get: function(idEntitat, id, form){
        var url = api + '/' + idEntitat + '/logos/' + id;
        return DataFactory.getWithParams(url, form);
      },
        
      add: function(idEntitat, obj){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.add(url,obj);
      },
      makeLogoPredeterminat:function(idEntitat, id){
        var url = api + '/' + idEntitat + '/logos/' + id + '/makeLogoPredeterminat';
        return DataFactory.update(url,{});
      },
      update: function(idEntitat, id, obj){
        var url = api + '/' + idEntitat + '/logos/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(idEntitat, id){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.delete(url, id);
      }
      
    };
    return LogoBase;
  }
}());
